import React, { useState, useContext } from "react";
import _ from "underscore";
import SystemContext from "../../../SystemContext";

const FuelSupplierValidator = (props) => {
  const record = props.data.record;
  const SystemData = useContext(SystemContext);

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  if (!error && !record.companyCode) {
    error = true;
    errorMessage = "'Company Code' is required";
  }
  if (!error && !record.companyName) {
    error = true;
    errorMessage = "'Company Name' is required";
  }
  // if (!error && !record.exchangeRateType) {
  //   error = true;
  //   errorMessage = "'Exchange Rate Provider' is required";
  // }
  // if (!error && !record.defaultCurrencyCode) {
  //   error = true;
  //   errorMessage = "'Default Currency Code' is required";
  // }
  // if (!error && !record.contractType) {
  //   error = true;
  //   errorMessage = "'Contract Type' is required";
  // }
  // if (!error && (SystemData.contractTypes.indexOf(record.contractType) < 0)) {
  //   error = true;
  //   errorMessage = "A valid 'Contract Type' is required";
  // }
  // if (!error && !record.pricePeriod) {
  //   error = true;
  //   errorMessage = "'Price Period' is required";
  // }
  // if (!error && (SystemData.pricePeriods.indexOf(record.pricePeriod) < 0)) {
  //   error = true;
  //   errorMessage = "A valid 'Price Period' is required";
  // }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default FuelSupplierValidator;
